import styles from 'components/Users/UserForm.module.css'
import React from 'react'
import { PasswordField } from 'components/Shared/PasswordField'
import { FieldComponent } from 'components/Shared/FieldComponent'

export function UserAccountFormFields ({ disableAccountFieldsHelperTextMargin, disabled, visible = true }) {
  if (!visible) return null

  return <>
    <div className={styles.container}>
      <div
        className={
          `${styles.usernameFieldContainer} 
           ${disableAccountFieldsHelperTextMargin ? styles.disableHelperTextMargin : ''}
          `
        }>
        <FieldComponent fieldName={'username'} label={'form.account.username'} disabled={disabled}/>
      </div>
      <PasswordField
        fieldName={'password'}
        label={'form.account.password'}
        disableAccountFieldsHelperTextMargin={disableAccountFieldsHelperTextMargin}
        disabled={disabled}
      />
      <PasswordField
        fieldName={'passwordConfirmation'}
        label={'form.account.passwordConfirmation'}
        disableAccountFieldsHelperTextMargin={disableAccountFieldsHelperTextMargin}
        disabled={disabled}
      />
    </div>
  </>
}
